import { configureStore } from "@reduxjs/toolkit";
import tabsSlice from "../components/header/tabs/tabsSlice";
import authSlice from "../auth/authSlice";

const store = configureStore({
  reducer: {
    tabs: tabsSlice.reducer,
    auth: authSlice.reducer,
  },
});

export default store;
